(function() {
  var WISHLIST_KEY = 'm-wishlist-products';
  var stack = document.querySelector('.m-wishlist-swipe__stack');
  var actionsEl = document.querySelector('.m-wishlist-swipe__actions');
  var doneEl = document.querySelector('.m-wishlist-swipe__done');
  var progressText = document.querySelector('.m-wishlist-swipe__progress');
  var progressFill = document.querySelector('.m-wishlist-swipe__progress-fill');
  var swipeView = document.querySelector('.m-wishlist-swipe__swipe-view');
  var compareView = document.querySelector('.m-wishlist-swipe__compare-view');
  var compareList = document.querySelector('.m-wishlist-swipe__compare-list');
  var progressWrapper = document.querySelector('.m-wishlist-swipe__progress-wrapper');
  if (!stack) return;

  var products = [];
  var selectedProducts = [];
  var cards = [];
  var currentIndex = 0;
  var history = [];
  var stats = { added: 0, skipped: 0 };
  var isDragging = false;
  var startX = 0, startY = 0, currentX = 0;
  var THRESHOLD = 80;

  function getHandles() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveHandles(handles) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
  }

  function formatMoney(cents) {
    return (parseInt(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  async function loadProducts() {
    var handles = getHandles();
    if (!handles.length) {
      document.querySelector('.m-wishlist-swipe__empty').style.display = 'block';
      stack.style.display = 'none';
      actionsEl.style.display = 'none';
      return;
    }

    for (var handle of handles) {
      try {
        var resp = await fetch('/products/' + handle + '.js');
        var data = await resp.json();
        if (data) products.push(data);
      } catch(e) {}
    }

    if (!products.length) {
      document.querySelector('.m-wishlist-swipe__empty').style.display = 'block';
      stack.style.display = 'none';
      actionsEl.style.display = 'none';
      return;
    }

    renderStack();
    updateProgress();
    setTimeout(showTutorial, 500);
  }

  function renderStack() {
    stack.innerHTML = '';
    cards = [];
    var count = Math.min(3, products.length - currentIndex);
    for (var i = count - 1; i >= 0; i--) {
      var idx = currentIndex + i;
      if (idx >= products.length) continue;
      var card = createCard(products[idx], i);
      stack.appendChild(card);
      cards.unshift(card);
    }
    if (cards.length) attachDrag(cards[0]);
  }

  function createCard(product, depth) {
    var card = document.createElement('div');
    card.className = 'm-wishlist-swipe__card';
    if (depth === 1) card.classList.add('m-wishlist-swipe__card--behind');
    if (depth >= 2) card.classList.add('m-wishlist-swipe__card--far');

    var img = product.featured_image || (product.images && product.images.length ? product.images[0] : '');
    if (img && !img.startsWith('http')) img = 'https:' + img;
    var variant = product.variants[0];
    var hasCompare = variant.compare_at_price && parseInt(variant.compare_at_price) > parseInt(variant.price);

    var priceHTML = '';
    if (hasCompare) {
      priceHTML = '<span class="m-wishlist-swipe__card-price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
                  '<span class="m-wishlist-swipe__card-price--sale">' + formatMoney(variant.price) + '</span>';
    } else {
      priceHTML = formatMoney(variant.price);
    }

    card.innerHTML =
      '<div class="m-wishlist-swipe__indicator m-wishlist-swipe__indicator--cart">Panier ✓</div>' +
      '<div class="m-wishlist-swipe__indicator m-wishlist-swipe__indicator--nope">Passer ✗</div>' +
      '<div class="m-wishlist-swipe__card-image">' +
        (img ? '<img src="' + img + '" alt="' + product.title + '" draggable="false" loading="eager">' : '') +
      '</div>' +
      '<div class="m-wishlist-swipe__card-info">' +
        '<p class="m-wishlist-swipe__card-brand">' + (product.vendor || '') + '</p>' +
        '<h3 class="m-wishlist-swipe__card-name">' + product.title + '</h3>' +
        '<div class="m-wishlist-swipe__card-price">' + priceHTML + '</div>' +
      '</div>';

    card.dataset.handle = product.handle;
    card.dataset.variantId = variant.id;
    return card;
  }

  function updateProgress() {
    var total = products.length;
    var done = currentIndex;
    if (progressText) progressText.textContent = (done) + ' / ' + total;
    if (progressFill) progressFill.style.width = (total ? (done / total * 100) : 0) + '%';
  }

  function attachDrag(card) {
    card.addEventListener('mousedown', onStart);
    card.addEventListener('touchstart', onStart, { passive: true });
  }

  function onStart(e) {
    isDragging = true;
    var point = e.touches ? e.touches[0] : e;
    startX = point.clientX;
    startY = point.clientY;
    currentX = 0;
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
  }

  function onMove(e) {
    if (!isDragging) return;
    var point = e.touches ? e.touches[0] : e;
    currentX = point.clientX - startX;
    var rotate = currentX * 0.08;
    var card = cards[0];
    if (card) {
      card.style.transform = 'translateX(' + currentX + 'px) rotate(' + rotate + 'deg)';
      card.style.transition = 'none';

      // Show indicators + background tint
      var cartInd = card.querySelector('.m-wishlist-swipe__indicator--cart');
      var nopeInd = card.querySelector('.m-wishlist-swipe__indicator--nope');
      var intensity = Math.min(Math.abs(currentX) / THRESHOLD, 1);
      if (cartInd) cartInd.style.opacity = intensity * (currentX > 0 ? 1 : 0);
      if (nopeInd) nopeInd.style.opacity = intensity * (currentX < 0 ? 1 : 0);

      var mix = Math.round(intensity * 30);
      if (currentX > 0) {
        card.style.backgroundColor = 'rgb(' + (255 - mix) + ',' + Math.min(255, 255 - mix + 20) + ',' + (255 - mix) + ')';
      } else if (currentX < 0) {
        card.style.backgroundColor = 'rgb(' + 255 + ',' + (255 - mix) + ',' + (255 - mix) + ')';
      } else {
        card.style.backgroundColor = '#fff';
      }
    }
    if (e.cancelable) e.preventDefault();
  }

  function onEnd() {
    isDragging = false;
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onEnd);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', onEnd);

    if (Math.abs(currentX) > THRESHOLD) {
      if (currentX > 0) {
        swipeRight();
      } else {
        swipeLeft();
      }
    } else {
      // Snap back
      var card = cards[0];
      if (card) {
        card.style.transition = 'transform 0.3s ease, background-color 0.3s ease';
        card.style.transform = '';
        card.style.backgroundColor = '#fff';
        var cartInd = card.querySelector('.m-wishlist-swipe__indicator--cart');
        var nopeInd = card.querySelector('.m-wishlist-swipe__indicator--nope');
        if (cartInd) cartInd.style.opacity = 0;
        if (nopeInd) nopeInd.style.opacity = 0;
      }
    }
  }

  function swipeRight() {
    var card = cards[0];
    if (!card) return;
    card.classList.add('m-wishlist-swipe__card--exiting-right');

    // Store product for review (don't add to cart yet)
    var handle = card.dataset.handle;
    var product = products.find(function(p) { return p.handle === handle; });
    if (product) selectedProducts.push(product);

    history.push({ index: currentIndex, action: 'right', handle: handle });
    stats.added++;
    advance();
  }

  function swipeLeft() {
    var card = cards[0];
    if (!card) return;
    card.classList.add('m-wishlist-swipe__card--exiting-left');

    // Remove from wishlist
    var handles = getHandles().filter(function(h) { return h !== card.dataset.handle; });
    saveHandles(handles);

    history.push({ index: currentIndex, action: 'left', handle: card.dataset.handle });
    stats.skipped++;
    advance();
  }

  function advance() {
    currentIndex++;
    updateProgress();

    setTimeout(function() {
      if (currentIndex >= products.length) {
        showDone();
      } else {
        renderStack();
      }
    }, 400);
  }

  function undo() {
    if (!history.length) return;
    var last = history.pop();
    currentIndex = last.index;

    if (last.action === 'left') {
      // Re-add to wishlist
      var handles = getHandles();
      handles.push(last.handle);
      saveHandles(handles);
      stats.skipped--;
    } else {
      stats.added--;
      // Note: we don't remove from cart for simplicity
    }

    updateProgress();
    doneEl.classList.remove('is-visible');
    stack.style.display = '';
    actionsEl.style.display = '';
    renderStack();
  }

  function showDone() {
    stack.style.display = 'none';
    actionsEl.style.display = 'none';
    if (progressWrapper) progressWrapper.style.display = 'none';

    // Update wishlist count
    document.querySelectorAll('.m-wishlist-count').forEach(function(el) {
      var count = getHandles().length;
      el.textContent = count;
      if (count < 1) el.classList.add('m:hidden');
    });

    if (selectedProducts.length > 0) {
      // Show review list
      renderReviewList();
    } else {
      // No products selected, show done message
      doneEl.classList.add('is-visible');
      document.querySelector('.m-wishlist-swipe__done-added').textContent = 0;
      document.querySelector('.m-wishlist-swipe__done-skipped').textContent = stats.skipped;
    }
  }

  // ===== Review list after swipe =====
  var reviewEl = document.querySelector('.m-wishlist-swipe__review');
  var reviewList = document.querySelector('.m-wishlist-swipe__review-list');

  function renderReviewList() {
    if (!reviewEl || !reviewList) return;
    reviewList.innerHTML = '';
    reviewEl.style.display = '';

    document.querySelector('.m-wishlist-swipe__review-count').textContent = selectedProducts.length + ' produit' + (selectedProducts.length > 1 ? 's' : '') + ' sélectionné' + (selectedProducts.length > 1 ? 's' : '');

    selectedProducts.forEach(function(product, idx) {
      var img = product.featured_image || (product.images && product.images.length ? product.images[0] : '');
      if (img && !img.startsWith('http')) img = 'https:' + img;
      var variants = product.variants || [];
      var firstAvailable = variants.find(function(v) { return v.available === true; });
      var defaultVariant = firstAvailable || variants[0];

      var sizesHTML = '';
      if (variants.length > 1) {
        sizesHTML = '<div class="m-wishlist-compare__sizes">';
        variants.forEach(function(v) {
          var cls = 'm-wishlist-compare__size';
          if (!v.available) cls += ' is-unavailable';
          if (firstAvailable && v.id === firstAvailable.id) cls += ' is-selected';
          sizesHTML += '<button class="' + cls + '" data-variant-id="' + v.id + '" data-variant-price="' + v.price + '" data-variant-compare="' + (v.compare_at_price || '') + '" data-available="' + v.available + '" type="button">' + v.title + '</button>';
        });
        sizesHTML += '</div>';
      }

      var hasCompare = defaultVariant && defaultVariant.compare_at_price && parseInt(defaultVariant.compare_at_price) > parseInt(defaultVariant.price);
      var priceHTML = hasCompare
        ? '<span class="m-wishlist-compare__price--compare">' + formatMoney(defaultVariant.compare_at_price) + '</span><span class="m-wishlist-compare__price--sale">' + formatMoney(defaultVariant.price) + '</span>'
        : formatMoney(defaultVariant.price);

      var card = document.createElement('div');
      card.className = 'm-wishlist-compare__card';
      card.dataset.productIndex = idx;
      card.innerHTML =
        '<button class="m-wishlist-compare__remove" data-review-remove="' + idx + '" aria-label="Supprimer">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="m-wishlist-compare__image">' +
          (img ? '<img src="' + img + '" alt="' + product.title + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="m-wishlist-compare__info">' +
          '<p class="m-wishlist-compare__brand">' + (product.vendor || '') + '</p>' +
          '<h3 class="m-wishlist-compare__name">' + product.title + '</h3>' +
          '<div class="m-wishlist-compare__price" data-price-container>' + priceHTML + '</div>' +
          sizesHTML +
        '</div>';

      reviewList.appendChild(card);

      // Size selector
      var sizeButtons = card.querySelectorAll('.m-wishlist-compare__size');
      sizeButtons.forEach(function(sizeBtn) {
        sizeBtn.addEventListener('click', function() {
          if (this.classList.contains('is-unavailable')) return;
          sizeButtons.forEach(function(b) { b.classList.remove('is-selected'); });
          this.classList.add('is-selected');
          // Update price
          var pc = card.querySelector('[data-price-container]');
          if (pc) {
            var vp = this.dataset.variantPrice;
            var vc = this.dataset.variantCompare;
            if (vc && parseInt(vc) > parseInt(vp)) {
              pc.innerHTML = '<span class="m-wishlist-compare__price--compare">' + formatMoney(vc) + '</span><span class="m-wishlist-compare__price--sale">' + formatMoney(vp) + '</span>';
            } else {
              pc.innerHTML = formatMoney(vp);
            }
          }
        });
      });

      // Remove button
      card.querySelector('[data-review-remove]').addEventListener('click', function() {
        var i = parseInt(this.dataset.reviewRemove);
        selectedProducts.splice(i, 1);
        card.style.transition = 'opacity 0.3s, transform 0.3s';
        card.style.opacity = '0';
        card.style.transform = 'translateX(-20px)';
        setTimeout(function() {
          card.remove();
          document.querySelector('.m-wishlist-swipe__review-count').textContent = selectedProducts.length + ' produit' + (selectedProducts.length > 1 ? 's' : '') + ' sélectionné' + (selectedProducts.length > 1 ? 's' : '');
          if (selectedProducts.length === 0) {
            reviewEl.style.display = 'none';
            doneEl.classList.add('is-visible');
            document.querySelector('.m-wishlist-swipe__done-added').textContent = 0;
            document.querySelector('.m-wishlist-swipe__done-skipped').textContent = stats.skipped;
          }
        }, 300);
      });
    });

    // Confirm all button
    var confirmBtn = document.querySelector('.m-wishlist-swipe__review-confirm');
    if (confirmBtn) {
      confirmBtn.onclick = function() {
        var items = [];
        reviewList.querySelectorAll('.m-wishlist-compare__card').forEach(function(card) {
          var selected = card.querySelector('.m-wishlist-compare__size.is-selected');
          if (selected) {
            items.push({ id: parseInt(selected.dataset.variantId), quantity: 1 });
          } else {
            // Single variant product
            var product = selectedProducts[parseInt(card.dataset.productIndex)];
            if (product && product.variants && product.variants.length) {
              var av = product.variants.find(function(v) { return v.available === true; });
              if (av) items.push({ id: av.id, quantity: 1 });
            }
          }
        });
        if (!items.length) return;

        confirmBtn.textContent = '...';
        confirmBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function() {
          window.location.href = '/cart';
        });
      };
    }
  }

  // Tutorial onboarding
  var TUTORIAL_KEY = 'm-wishlist-swipe-tutorial-seen';

  function showTutorial() {
    if (localStorage.getItem(TUTORIAL_KEY)) return;
    if (!cards.length) return;

    var card = cards[0];

    // Create overlay with finger
    var tutorial = document.createElement('div');
    tutorial.className = 'm-wishlist-swipe__tutorial is-active';
    tutorial.innerHTML = '<div class="m-wishlist-swipe__finger">👆</div>';
    stack.appendChild(tutorial);

    // Animate card: first left tilt, then right tilt
    card.classList.add('tutorial-left', 'tutorial-right');

    // Block dragging during tutorial
    card.style.pointerEvents = 'none';

    // Cleanup after animation
    var duration = 3600;
    setTimeout(function() {
      tutorial.classList.remove('is-active');
      card.classList.remove('tutorial-left', 'tutorial-right');
      card.style.pointerEvents = '';
      card.style.transform = '';
      setTimeout(function() { tutorial.remove(); }, 300);
      localStorage.setItem(TUTORIAL_KEY, '1');
    }, duration);

    // Allow skip by tapping
    tutorial.addEventListener('click', function() {
      tutorial.classList.remove('is-active');
      card.classList.remove('tutorial-left', 'tutorial-right');
      card.style.pointerEvents = '';
      card.style.transform = '';
      card.querySelectorAll('.m-wishlist-swipe__indicator').forEach(function(ind) { ind.style.opacity = 0; });
      setTimeout(function() { tutorial.remove(); }, 300);
      localStorage.setItem(TUTORIAL_KEY, '1');
    });
  }

  // ===== Compare mode =====
  function renderCompareView() {
    if (!compareList) return;
    compareList.innerHTML = '';

    products.forEach(function(product) {
      var img = product.featured_image || (product.images && product.images.length ? product.images[0] : '');
      if (img && !img.startsWith('http')) img = 'https:' + img;
      var variants = product.variants || [];
      var firstAvailable = variants.find(function(v) { return v.available === true; });
      var anyAvailable = product.available === true || !!firstAvailable;
      var defaultVariant = firstAvailable || variants[0];
      var hasCompare = defaultVariant && defaultVariant.compare_at_price && parseInt(defaultVariant.compare_at_price) > parseInt(defaultVariant.price);

      var priceHTML = '';
      if (hasCompare) {
        priceHTML = '<span class="m-wishlist-compare__price--compare">' + formatMoney(defaultVariant.compare_at_price) + '</span>' +
                    '<span class="m-wishlist-compare__price--sale">' + formatMoney(defaultVariant.price) + '</span>';
      } else if (defaultVariant) {
        priceHTML = formatMoney(defaultVariant.price);
      }

      // Build size buttons
      var sizesHTML = '';
      if (variants.length > 1) {
        sizesHTML = '<div class="m-wishlist-compare__sizes">';
        variants.forEach(function(v, idx) {
          var cls = 'm-wishlist-compare__size';
          if (!v.available) cls += ' is-unavailable';
          if (firstAvailable && v.id === firstAvailable.id) cls += ' is-selected';
          sizesHTML += '<button class="' + cls + '" data-variant-id="' + v.id + '" data-variant-price="' + v.price + '" data-variant-compare="' + (v.compare_at_price || '') + '" data-available="' + v.available + '" type="button">' + v.title + '</button>';
        });
        sizesHTML += '</div>';
      }

      var card = document.createElement('div');
      card.className = 'm-wishlist-compare__card';
      card.innerHTML =
        '<button class="m-wishlist-compare__remove" data-handle="' + product.handle + '" aria-label="Supprimer">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="m-wishlist-compare__image">' +
          (img ? '<img src="' + img + '" alt="' + product.title + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="m-wishlist-compare__info">' +
          '<p class="m-wishlist-compare__brand">' + (product.vendor || '') + '</p>' +
          '<h3 class="m-wishlist-compare__name">' + product.title + '</h3>' +
          '<div class="m-wishlist-compare__price" data-price-container>' + priceHTML + '</div>' +
          sizesHTML +
          (anyAvailable
            ? '<button class="m-wishlist-compare__add-btn" data-variant-id="' + (firstAvailable ? firstAvailable.id : '') + '" type="button">Ajouter au panier</button>'
            : '<button class="m-wishlist-compare__add-btn" disabled type="button">Épuisé</button>') +
        '</div>';

      compareList.appendChild(card);

      // Size selector logic
      var sizeButtons = card.querySelectorAll('.m-wishlist-compare__size');
      var addBtn = card.querySelector('.m-wishlist-compare__add-btn');
      var priceContainer = card.querySelector('[data-price-container]');

      sizeButtons.forEach(function(sizeBtn) {
        sizeBtn.addEventListener('click', function() {
          if (this.classList.contains('is-unavailable')) return;
          // Deselect all
          sizeButtons.forEach(function(b) { b.classList.remove('is-selected'); });
          this.classList.add('is-selected');
          // Update add button variant
          if (addBtn) {
            addBtn.dataset.variantId = this.dataset.variantId;
            addBtn.disabled = false;
            addBtn.textContent = 'Ajouter au panier';
            addBtn.classList.remove('is-added');
          }
          // Update price
          if (priceContainer) {
            var vPrice = this.dataset.variantPrice;
            var vCompare = this.dataset.variantCompare;
            if (vCompare && parseInt(vCompare) > parseInt(vPrice)) {
              priceContainer.innerHTML = '<span class="m-wishlist-compare__price--compare">' + formatMoney(vCompare) + '</span><span class="m-wishlist-compare__price--sale">' + formatMoney(vPrice) + '</span>';
            } else {
              priceContainer.innerHTML = formatMoney(vPrice);
            }
          }
        });
      });

      // Add to cart
      if (addBtn && !addBtn.disabled) {
        addBtn.addEventListener('click', function() {
          var self = this;
          var vid = self.dataset.variantId;
          if (!vid) return;
          self.textContent = '...';
          self.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
          }).then(function() {
            self.textContent = '✓ Ajouté';
            self.classList.add('is-added');
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              document.querySelectorAll('.m-cart-count').forEach(function(el) {
                el.textContent = cart.item_count;
                el.classList.remove('m:hidden');
              });
            });
            // Remove from wishlist and animate out
            var handle = card.querySelector('.m-wishlist-compare__remove')?.dataset?.handle;
            if (handle) {
              var handles = getHandles().filter(function(h) { return h !== handle; });
              saveHandles(handles);
              document.querySelectorAll('.m-wishlist-count').forEach(function(el) {
                el.textContent = handles.length;
                if (handles.length < 1) el.classList.add('m:hidden');
              });
            }
            setTimeout(function() {
              card.style.transition = 'opacity 0.4s, transform 0.4s';
              card.style.opacity = '0';
              card.style.transform = 'scale(0.95) translateY(-10px)';
              setTimeout(function() {
                card.remove();
                if (compareList && compareList.children.length === 0) {
                  window.location.href = '/cart';
                }
              }, 400);
            }, 800);
          });
        });
      }

      // Remove
      var removeBtn = card.querySelector('.m-wishlist-compare__remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', function() {
          var handle = this.dataset.handle;
          var handles = getHandles().filter(function(h) { return h !== handle; });
          saveHandles(handles);
          card.style.transition = 'opacity 0.3s, transform 0.3s';
          card.style.opacity = '0';
          card.style.transform = 'translateX(-20px)';
          setTimeout(function() {
            card.remove();
            if (compareList && compareList.children.length === 0) {
              window.location.href = '/cart';
            }
          }, 300);
          // Update wishlist count
          document.querySelectorAll('.m-wishlist-count').forEach(function(el) {
            el.textContent = handles.length;
            if (handles.length < 1) el.classList.add('m:hidden');
          });
        });
      }
    });
  }

  // ===== Mode toggle =====
  document.querySelectorAll('.m-wishlist-swipe__mode').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.m-wishlist-swipe__mode').forEach(function(b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      var mode = this.dataset.mode;

      if (mode === 'swipe') {
        swipeView.style.display = '';
        compareView.style.display = 'none';
        if (progressWrapper) progressWrapper.style.display = '';
      } else {
        swipeView.style.display = 'none';
        compareView.style.display = '';
        if (progressWrapper) progressWrapper.style.display = 'none';
        renderCompareView();
      }
    });
  });

  // Button handlers
  document.querySelector('.m-wishlist-swipe__btn--nope')?.addEventListener('click', function() {
    if (cards[0] && currentIndex < products.length) swipeLeft();
  });
  document.querySelector('.m-wishlist-swipe__btn--cart')?.addEventListener('click', function() {
    if (cards[0] && currentIndex < products.length) swipeRight();
  });
  document.querySelector('.m-wishlist-swipe__btn--undo')?.addEventListener('click', undo);

  loadProducts();
})();
